import { isMobileDevice } from '@core/helpers/client'
import { isNotOnBlocklistedRoute } from '@tracking/helpers'

export function canLoadAppsflyer({
  country,
  $config,
  store,
  blocklistedRoutesCollections,
  currentRoute,
}) {
  const userAgent = store.getters['config/userAgent']
  const isRealMobileDevice = isMobileDevice(userAgent)

  const isMobileAppAvailable = store.getters['config/isMobileAppAvailable']
  const isEnabledInCurrentCountry =
    $config.FF_APPSFLYER_ENABLED_BY_COUNTRY?.includes(country)
  const isKilled = $config.KILL_APPSFLYER

  const isGrantedOnCurrentRoute = isNotOnBlocklistedRoute({
    blocklistedRoutesCollections,
    currentRoute,
  })

  return (
    isRealMobileDevice &&
    isMobileAppAvailable &&
    isEnabledInCurrentCountry &&
    isGrantedOnCurrentRoute &&
    !isKilled
  )
}
